module.exports = __webpack_public_path__ + "img/5-on.11c0f399.png";